import PropTypes from "prop-types"
import React from "react"
import Button from "semantic-ui-react/dist/es/elements/Button/Button"
import Container from "semantic-ui-react/dist/es/elements/Container/Container"
import Header from "semantic-ui-react/dist/es/elements/Header/Header"
import Modal from "semantic-ui-react/dist/es/modules/Modal/Modal"

export default class Async extends React.Component {
  static propTypes = {
    resolve: PropTypes.func.isRequired,
    pending: PropTypes.node,
    fulfilled: PropTypes.func.isRequired,
    rejected: PropTypes.func,
    args: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.string,
      PropTypes.number
    ])
  }

  static defaultProps = {
    pending: () => null,
    rejected: error => (
      <pre style={{ color: "red" }}>{JSON.stringify(error, null, 2)}</pre>
    )
  }

  constructor(props) {
    super(props)
    this.state = {
      status: "pending",
      result: null
    }
    this.cancelled = false
  }

  resolvePromise = resolve => {
    this.setState(
      {
        status: "pending",
        result: null
      },
      () => {
        resolve(this.props.args).then(
          data => {
            if (!this.cancelled) {
              this.setState({
                status: "fulfilled",
                result: data
              })
            }
          },
          error => {
            if (!this.cancelled) {
              this.setState({
                status: "rejected",
                result: error,
                errorType: error.name
              })
            }
          }
        )
      }
    )
  }

  componentDidMount() {
    if (this.props.resolve) {
      this.resolvePromise(this.props.resolve)
    }
  }

  componentWillUnmount() {
    this.cancelled = true
  }

  componentDidUpdate = prevProps => {
    if (this.state.status !== "pending" && this.props.args !== prevProps.args) {
      this.resolvePromise(this.props.resolve)
    }
  }

  // resolve functions often created inline which creates a
  // new function each render even if the underlying/wrapped
  // function hasn't really changed. since we don't even
  // need to handle this case, we're removing it
  // componentDidUpdate(prevProps) {
  //   // may be called if props haven't changed
  //   if (prevProps.resolve !== this.props.resolve) {
  //     this.resolvePromise(this.props.resolve)
  //   }
  // }

  render() {
    if (this.state.status === "pending") {
      return this.props.pending
    } else if (this.state.status === "fulfilled") {
      return this.props.fulfilled(this.state.result)
    } else if (this.state.errorType in errorTypes) {
      return (
        <AsyncErrorNotice
          {...errorTypes[this.state.errorType]}
          onTryAgain={() => this.resolvePromise(this.props.resolve)}
        />
      )
    } else {
      return this.props.rejected()
    }
  }
}

const AsyncErrorNotice = ({ header, content, onTryAgain }) => (
  <Modal defaultOpen={true} size="tiny" closeOnDimmerClick={false}>
    <Modal.Content>
      <Container textAlign="center">
        <Header content={header} color="red" />
        <p className="greyed-text">{content}</p>
        <Button primary content="Try again" onClick={onTryAgain} />
      </Container>
    </Modal.Content>
  </Modal>
)

AsyncErrorNotice.propTypes = {
  header: PropTypes.string,
  content: PropTypes.string,
  onTryAgain: PropTypes.func.isRequired
}

AsyncErrorNotice.defaultProps = {
  header: "Oops! Something went wrong.",
  content: `We couldn't connect to the server.`
}

const errorTypes = {
  NetworkError: {
    header: "Oops! Something went wrong.",
    content: `We couldn't connect to the server.`
  },
  NotFoundError: {
    header: `That does't exist!`,
    content: `Sorry, we couldn't find that thing you were looking for.`
  }
}
